// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__20Jac","header":"MessagesList_header__73BtV","chat":"MessagesList_chat__3MUwb"};